<template>
    <div class="w-100 d-flex justify-content-center">
        <div
            v-for="(column, index) in node.columns"
            :key="index"
            :style="getColumnStyleBlock(column)"
            class="flex-shrink-1 d-flex flex-column mw-100"
        >
            <div
                class="flex-grow-1 d-flex flex-column h-100 bg-white rounded panel-type-card panel-type-card-available panel"
                v-for="panel in column.panels"
                :key="panel.id"
            >
                <div
                    class="flex-grow-1 card-body d-flex align-items-center panel-layout-preview"
                    :class="{ 'py-3': !tinyMode, 'py-2': tinyMode }"
                    @click="openEditPanel(panel)"
                >
                    <div class="flex-fill">
                        <div class="d-flex justify-content-center icon-container">
                            <div class="text-secondary d-flex align-items-center">
                                <div v-if="panel.show_video_first" class="d-flex align-items-center">
                                    <span
                                        class="icon icon-glyphicons-basic-film icon-margin"
                                        :class="[tinyMode ? 'panel-preview-icon-sm' : 'panel-preview-icon']"
                                    ></span>
                                    <span
                                        class="icon icon-100 icon-glyphicons-basic-arrow-thin-right icon-margin"
                                    ></span>
                                </div>
                                <div :class="[tinyMode ? 'panel-preview-icon-sm' : 'panel-preview-icon']">
                                    <span class="icon text-secondary" :class="panelTypeIcon(panel.panel_type)"></span>
                                </div>
                            </div>
                        </div>
                        <div>
                            <p
                                class="text-center mb-0 font-weight-500"
                                :class="{ 'map-label-tiny': tinyMode, 'map-label': !tinyMode }"
                            >
                                {{ panelTypeLabel(panel.panel_type) }}
                            </p>
                            <p v-if="showHeaders" class="text-center mb-0 mt-1 tiny text-secondary">
                                {{ panel.header }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="nodeIsEmpty && !loading" class="h-100 d-flex align-items-center">
            <span class="text-center font-weight-500 text-secondary">No content added yet.</span>
        </div>
    </div>
</template>

<script>
import { panelTypeIcons, panelTypeLabels } from "@/assets/js/settings.js"

export default {
    name: "NodeContentPreview",
    props: {
        // The node whose content is being viewed.
        node: {
            type: Object,
            required: false,
            default() {
                return {
                    columns: [],
                }
            },
        },
        // When true, panel headers are displayed.
        showHeaders: {
            type: Boolean,
            required: false,
            default: true,
        },
        // When true, content is displayed in a more condensed format.
        tinyMode: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {}
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        nodeIsEmpty() {
            return this.node.columns.length === 0
        },
    },
    methods: {
        // Returns a style object controlling the displayed width of a column.
        getColumnStyleBlock(column) {
            let normalScreenWidth = 1600
            let scaled = Math.min(column.width / normalScreenWidth, 1)
            return {
                width: scaled * 100 + "%",
            }
        },
        // Returns the icon class name based on the panel type passed in.
        panelTypeIcon(panelType) {
            return panelTypeIcons[panelType]
        },
        // Returns the display-friendly panel label based on the panel type passed in.
        panelTypeLabel(panelType) {
            let label = ""
            try {
                label = panelTypeLabels[panelType]
            } catch (error) {
                label = "Content"
            }
            return label
        },
        // Open the edit panel modal and fetch the panel data.
        openEditPanel(panel) {
            this.$emit("edit", panel)
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/paneledit.scss";

.panel {
    margin: 4px;
}

.panel-preview-icon {
    font-size: 1.4rem;
}

.panel-preview-icon-sm {
    font-size: 1.1rem;
}

.icon-container {
    margin-bottom: 2px;
}

.icon-margin {
    margin-right: 4px;
}

.map-label {
    font-size: 80%;
    margin-top: 6px;
}

.map-label-tiny {
    font-size: 70%;
    margin-top: 4px;
}
</style>